import React, { useEffect, useState } from 'react';
import { WithStyles } from '@material-ui/core/styles';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { withStyles } from '@material-ui/core';
import Dashboard from '../../../../layouts/Dashboard';
import EditLocationIntegrations from '../../../../components/Global/LocationIntegrations/Edit';
import { locationIntegrationsEditInitQuery } from './queries';
import styles from './styles';

interface Props extends WithStyles<typeof styles>, RouteComponentProps {
  classes: ClassNameMap<string>;
}

const LocEditIntegrations = ({ classes, history }: Props): React.ReactElement => {
  const [locationId, setLocationId] = useState<string>('');

  const { data } = useQuery(locationIntegrationsEditInitQuery, { fetchPolicy: 'no-cache' });

  useEffect(() => {
    if (data?.locations?.[0]) {
      setLocationId(data.locations[0].id);
    }
  }, [data]);

  const handleFinish = () => {
    history.push('/loc/integrations');
  };

  if (!locationId) {
    return <Dashboard title="Integrations"><div /></Dashboard>;
  }

  return (
    <Dashboard title="Edit Integrations">
      <EditLocationIntegrations location_id={locationId} handleFinish={handleFinish} />
    </Dashboard>
  );
};

export default withRouter(withStyles(styles)(LocEditIntegrations));
